import { SdkEventInterface } from "@modules/sdk/events/SdkEventInterface";

import { WISHLISTS_SDK_EVENTS } from "../constants";

class WishlistItemCreatedSdkEvent implements SdkEventInterface {
    public readonly type: WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED;

    constructor(
        public readonly wishlistId: number,
        public readonly productId: number,
        public readonly variantId: number
    ) {
        this.type = WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED;
    }
}

export default WishlistItemCreatedSdkEvent;
